import { useState, useCallback } from 'react';
import { IOptionType } from '../Jobs/types';
import Api from '../Jobs/API';

interface FilterLocationOptionsResponse {
  res: string[];
  resHead: {
    [key: string]: string;
  };
}

export const useLocationFilterOptions = () => {
  const [data, setData] = useState<IOptionType[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async (archived: boolean) => {
    setIsLoading(true);
    try {
      let page = 1;
      let totalPages = 9999;
      let results: string[] = [];

      while (page <= totalPages) {
        const response = (await Api.getJobFilterOptionsPaginated('locations', {
          'filter[archived]': archived,
          page
        })) as FilterLocationOptionsResponse;

        const currentPageData = response.res || [];
        results = [...results, ...currentPageData];

        if (page === 1) {
          const transformedResults = results.map((location) => ({
            label: location,
            name: location
          }));
          setData(transformedResults);
        }

        totalPages = parseInt(response.resHead?.['x-total-pages'] || '1');
        page += 1;
      }

      if (page > 1) {
        const transformedResults = results.map((location) => ({
          label: location,
          name: location
        }));
        setData(transformedResults);
      }
    } catch (error) {
      console.error('Error fetching locations:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { data, isLoading, fetchData };
};
